import React from 'react';
import PropTypes from 'prop-types';

import { ElementClickTracker } from '../../analytics/cohesion';
import { ELEVATED_PROMO_PRICE_ROW_LAYOUT } from '../../constants/campaignPromoVariants';
import { ELEVATED_CAMPAIGN_PROMO_UI } from '../../constants/elevatedCampaignPromoUi';
import {
  MAX_PROVIDERS_LIMIT,
  SIGN_UP_ELEVATE_PRESENCE_TRACKING,
} from '../../constants/subscriptions';
import Button from '../Shared/Button';
import { ElevatedPromoPriceRow } from './PromoPriceDisplay';

const CampaignPromoHeroCard = ({ onCtaClick }) => {
  const { heroPromoCard } = ELEVATED_CAMPAIGN_PROMO_UI;
  const providersNote = `Elevated Profile Subscriptions are available for individual healthcare professionals or group practices with up to ${MAX_PROVIDERS_LIMIT} providers.`;

  return (
    <div
      className="mb-10 flex w-full flex-col items-center gap-5 border-b border-gray-20 px-6 pb-10 md:px-0"
      data-qa-target="campaign-promo-hero-card"
    >
      <div className="flex max-w-[327px] flex-col gap-1 text-center text-blue-90 sm:max-w-none">
        <h2 className="text-[28px] font-semibold leading-9 sm:text-4xl sm:leading-[52px] md:text-5xl md:leading-[72px]">
          {heroPromoCard.headline}
        </h2>
        <p className="text-base font-semibold leading-5 md:text-2xl md:leading-9">
          {heroPromoCard.subhead}
        </p>
      </div>
      <div className="w-full max-w-[327px] text-center md:max-w-[928px]">
        <ElevatedPromoPriceRow
          layout={ELEVATED_PROMO_PRICE_ROW_LAYOUT.INLINE}
          providersNote={providersNote}
        />
      </div>
      <ElementClickTracker {...SIGN_UP_ELEVATE_PRESENCE_TRACKING}>
        <Button
          variant="primary"
          size="medium"
          className="w-full md:w-56"
          onClick={onCtaClick}
        >
          {heroPromoCard.cta}
        </Button>
      </ElementClickTracker>
    </div>
  );
};

CampaignPromoHeroCard.propTypes = {
  onCtaClick: PropTypes.func.isRequired,
};

export default CampaignPromoHeroCard;
